<template lang="html">
    <div class="ps-home-banner ps-home-banner--1 mt-0 pt-0">
        <div class="ps-container p-0">
            <div class="ps-section__left row m-0 w-100 pr-0"
                v-if="bannersDesk && bannersMobile && bannersDesk.length !== 0 && bannersMobile.length !== 0">
                <div class="ps-carousel col-12 p-0" v-swiper:mySwiper="swiperOption">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide desktop-view banner-bg" style="cursor: pointer"
                            v-for="(item, index) in bannersDesk"
                            :key="index"
                            @click="nav(item.link)">
                            
                            <!-- Show countdown above first slide -->
                            <!-- <div v-if="index === 0 && countdown" class="countdown-timer">
                                {{ countdown }}
                            </div> -->

                            <!-- Countdown overlay only on first slide -->
<!-- <div v-if="index === 0 && countdown" class="countdown-ui">
    <div class="countdown-card">
        <div class="title">BIGGEST LAUNCH OF<br />2025</div>
      <div class="time-blocks">
    <div class="digit-box" v-for="(digit, i) in countdown.hours.split('')" :key="'h' + i">{{ digit }}</div>
    <div class="colon">:</div>
    <div class="digit-box" v-for="(digit, i) in countdown.minutes.split('')" :key="'m' + i">{{ digit }}</div>
    <div class="colon">:</div>
    <div class="digit-box" v-for="(digit, i) in countdown.seconds.split('')" :key="'s' + i">{{ digit }}</div>
</div>
        <div class="labels">
            <span>hours</span>
            <span>minutes</span>
            <span>seconds</span>
        </div>
        <div class="action-btn">
            <i class="icon-chevron-right"></i>
        </div>
    </div>
</div> -->


                            <div class="ps-banner" :style="{
                                backgroundSize: 'contain',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center center',
                                backgroundImage: `url(${item.pictures})`
                            }"></div>
                        </div>
                    </div>

                    <!-- Carousel arrows -->
                    <div class="swiper-nav">
                        <span class="swiper-arrow swiper-prev"><i class="icon-chevron-left"></i></span>
                        <div class="swiper-arrow swiper-next">
                            <i class="icon-chevron-right"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'HomeBanner',
    props: {
        homepageData: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },
    data() {
        return {
            bannersMobile: [],
            bannersDesk: [],
          countdown: {
  hours: '00',
  minutes: '00',
  seconds: '00'
},
            launchTime: null,
            timerInterval: null,
            swiperOption: {
                loop: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false
                },
                slidesPerView: 1,
                spaceBetween: 1,
                navigation: {
                    nextEl: '.swiper-next',
                    prevEl: '.swiper-prev'
                }
            }
        };
    },
    mounted() {
        this.bannersMobile = this.homepageData.bannerMobile;
        this.bannersDesk = this.homepageData.bannerDesktop;

        const now = new Date();
        const launch = new Date();
        launch.setHours(19, 30, 0, 0); // 7:30 PM today

        if (now < launch) {
            this.launchTime = launch;
            this.startCountdown();
        }
    },
    methods: {
        nav(url) {
            window.open(url, "_blank");
        },
        startCountdown() {
            this.updateCountdown();
            this.timerInterval = setInterval(() => {
                this.updateCountdown();
            }, 1000);
        },
      updateCountdown() {
    const now = new Date();
    const diff = this.launchTime - now;

    if (diff <= 0) {
        clearInterval(this.timerInterval);
        this.countdown = null;
        return;
    }

    const hours = String(Math.floor(diff / (1000 * 60 * 60))).padStart(2, '0');
    const minutes = String(Math.floor((diff / (1000 * 60)) % 60)).padStart(2, '0');
    const seconds = String(Math.floor((diff / 1000) % 60)).padStart(2, '0');

    this.countdown = { hours, minutes, seconds };
}

    },
    beforeDestroy() {
        clearInterval(this.timerInterval);
    }
};

</script>
<style lang="scss" scoped>
 .countdown-timer {
    position: absolute;
    top: 50%;
    left: 10%;
    background-color: rgba(0, 0, 0, 0.2);
    color: #fff;
    padding: 25px 18px;
    border-radius: 8px;
    font-size: 36px;
    z-index: 10;
}
.countdown-ui {
    position: absolute;
    top: 50%;
    left: 10%;
    z-index: 10;
    font-family: sans-serif;
}
.time-blocks {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
}

.digit-box {
    background: #f2f2f2;
    border-radius: 6px;
    padding: 12px 10px;
    font-size: 24px;
    font-weight: bold;
    width: 32px;
    margin: 0 2px;
    text-align: center;
    color: #000;
}

.colon {
    margin: 0 6px;
    font-size: 24px;
    font-weight: bold;
    color: #000;
}


.countdown-card {
    background: white;
    border-radius: 20px;
    padding: 20px 24px;
    width: max-content;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
    text-align: center;
    position: relative;
}

.countdown-card .title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 16px;
    line-height: 1.3;
    color: #000;
}

.time-blocks {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
}

.time-box {
    background: #f2f2f2;
    border-radius: 8px;
    padding: 12px 10px;
    font-size: 24px;
    font-weight: bold;
    width: 40px;
    text-align: center;
    color: #000;
}

.colon {
    margin: 0 6px;
    font-size: 24px;
    font-weight: bold;
    color: #000;
}

.labels {
    display: flex;
    justify-content: space-around;
    font-size: 12px;
    color: #555;
    margin-top: 6px;
}

.labels span {
    width: 40px;
    text-align: center;
}

.action-btn {
    position: absolute;
    right: 12px;
    top: 12px;
    width: 28px;
    height: 28px;
    background: #f5f5f5;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 16px;
}

.swiper-arrow {
    width: 15px;
    height: 15px;
    border: 2px solid #000;
    background-color: #fff;

    border-radius: 50px;

    &:hover {
        background-color: #f07720;

    }
}

.ps-carousel .swiper-arrow i {
    font-size: 13px;
}

.swiper-arrow {
    // display: inline-block;
    // vertical-align: top;
    // position: relative;
    width: 25px;
    height: 25px;
    border: none;
    // background-color: #000;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    // border-radius: 0;
    // z-index: 100;
    // cursor: pointer;
    // transition: all 0.25s ease;
    // outline: none;
}

.swiper-nav {
    //  float: right;
    // display: flex;
    // flex-flow: wrap-reverse;
    top: 56%;
    // width: 35%;
    /* padding-top: 2%; */
    // justify-content: space-between;
    // align-items: flex-end;
    height: 0;
}

.slide {
    height: 300px;
    background: #ccc;
    text-align: center;
    line-height: 300px;
}

.slick-track {
    margin: 25px auto;
    width: 500px;
}

.slick-dots-container {
    width: 5.5rem;
    overflow: hidden;
    display: block;
    padding: 0;
    margin: 0.625rem auto;
    height: 0.875rem;
    position: relative;
}

.slick-dots-container>ul {
    padding: 0;
    display: flex;
    transition: all 0.25s;
    position: relative;
    margin: 0;
    list-style: none;
    transform: translateX(0);
    align-items: center;
    bottom: unset;
    height: 100%;
}

.slick-dots-container>ul li {
    width: 0.625rem;
    height: 0.625rem;
    margin: 0 0.25rem;
    background-color: #efd5d5;
    border: none;
    border-radius: 50%;
}

.slick-dots-container>ul li button {
    font-size: 0;
    line-height: 0;
    display: block;
    width: 1.25rem;
    height: 1.25rem;
    padding: 0.3125rem;
    cursor: pointer;
    color: transparent;
    border: 0;
    outline: 0;
    background: 0 0;
}

.slick-dots-container>ul li.p-small-1,
.slick-dots-container>ul li.n-small-1 {
    transform: scale(0.8);
}

.slick-dots-container>ul li.slick-active {
    transform: scale(1.3);
    transform-origin: center;
    background: #3498db;
}

.slick-dots li button:before {
    display: none;
}


.slick-track {
    height: 180px;
}

.slick-dots {
    overflow: hidden;
    display: block;
    padding: 0;
    margin: 0.625rem auto;
    height: 0.875rem;
    position: relative;
}

// .carousel-wrapper {
//   padding: 40px;
// }
// .img-wrapper img {
//   margin: auto;
//   width: 200px;
//   height: 100px;
//   background-image: linear-gradient(gray 100%, transparent 0);
// }
// html,
// body {
//   height: 100%;
//   margin: 0px;
// }

// .slider-container {
//   background: linear-gradient(
//     149deg,
//     rgb(247, 0, 255) 0%,
//     rgb(255, 145, 0) 100%
//   );
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   height: 100%;
// }

// // /
// .slides {
//   display: flex;
//   overflow-x: scroll;
//   position: relative;
//   scroll-behavior: smooth;
//   scroll-snap-type: x mandatory;
// }

// .slide:nth-of-type(even) {
//   background-color: rgb(250, 246, 212);
// }

// .slide {
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   flex-shrink: 0;
//   width: 100%;
//   height: 400px;
//   scroll-snap-align: center;
//   margin-right: 0px;
//   box-sizing: border-box;
//   background: white;
//   transform-origin: center center;
//   transform: scale(1);
// }

// .slide__text {
//   font-size: 40px;
//   font-weight: bold;
//   font-family: sans-serif;
// }

// .slide a {
//   background: none;
//   border: none;
// }

// a.slide__prev,
// .slider::before {
//   transform: rotate(135deg);
//   -webkit-transform: rotate(135deg);
//   left: 5%;
// }

// a.slide__next,
// .slider::after {
//   transform: rotate(-45deg);
//   -webkit-transform: rotate(-45deg);
//   right: 5%;
// }

// .slider::before,
// .slider::after,
// .slide__prev,
// .slide__next {
//   position: absolute;
//   top: 48%;
//   width: 35px;
//   height: 35px;
//   border: solid black;
//   border-width: 0 4px 4px 0;
//   padding: 3px;
//   box-sizing: border-box;
// }

// .slider::before,
// .slider::after {
//   content: "";
//   z-index: 1;
//   background: none;
//   pointer-events: none;
// }

// .slider__nav {
//   box-sizing: border-box;
//   position: absolute;
//   bottom: 5%;
//   left: 50%;
//   width: 200px;
//   margin-left: -100px;
//   text-align: center;
// }

// .slider__navlink {
//   display: inline-block;
//   height: 15px;
//   width: 15px;
//   border-radius: 50%;
//   background-color: black;
//   margin: 0 10px 0 10px;
// }








// .read-article{
//   position: absolute;
//   top: 10px;
//   left: 10px;
//   z-index: 999;
//   color: #000;
//   background: white;
//   padding: 10px 20px;
//   border-radius: 10px;
//   font-family: arial;
//   text-decoration: none;
//   box-shadow: rgb(50 50 93 / 25%) 0 0 100px -20px, rgb(0 0 0 / 30%) 0 0 60px -15px;
// }
// .read-article:hover{
//     background: #d5d5d5;
//     box-shadow: rgb(50 50 93 / 25%) 0 0 100px -20px, rgb(0 0 0 / 30%) 0 0 60px 0px;
// }
// iframe[sandbox] .read-article{
//   display: none;
// }
.ps-section__left {
    max-width: 100% !important;
    width: 100% !important;
}

#homepage-1 .ps-home-banner .swiper-container {
    height: 100% !important;

    .swiper-wrapper {
        height: 450px !important;
        // height: 100% !important;

    }
}

.desktop-view {
    display: block;
}

.mobile-view {
    display: none;
}

@media (max-width: 767px) {
    .desktop-view {
        display: none;
    }

    .mobile-view {
        display: block;
    }

    .ps-banner {
        background-size: 100%;
        background-color: #3498db !important;
        // height:300px !important;
    }
   

.swiper-slide {
    position: relative;
}


    #homepage-1 .ps-home-banner .swiper-container {
        height: 200px !important;

        .swiper-wrapper {
            height: 200px !important;
        }
    }
}
</style>
